// src/stores/patients.js
import { defineStore } from 'pinia'
import { axios } from '../axios';

export const usePatientStore = defineStore('patients', {
  state: () => ({
    items: [],
    loading: false,
  }),

  actions: {
    async fetchPatients() {
      this.loading = true
      try {
        const { data } = await axios.get('patients/')
        this.items = data
        return data
      } finally {
        this.loading = false
      }
    },

    // En tu backend actual no hay campos editables de paciente,
    // así que el payload suele ir vacío.
    async createPatient(payload = {}) {
      const { data } = await axios.post('patients/', payload)
      this.items.push(data)
      return data
    },

    async updatePatient(id, payload = {}) {
      const { data } = await axios.patch(`patients/${id}/`, payload)
      const idx = this.items.findIndex(p => p.id === data.id)
      if (idx !== -1) {
        this.items.splice(idx, 1, data)
      }
      return data
    },

    async deletePatient(id) {
      await axios.delete(`patients/${id}/`)
      this.items = this.items.filter(p => p.id !== id)
    },
  },
})
